<template>
  <v-container>
    <v-layout row wrap>
      <div xs12 v-for="(elem, index) in numberAccor" xs12 class="accordion">
        <button class="accordion-bot" @click="accorClick(index)">
          <slot :name="'title-'+index"></slot>
          <v-icon aria-hidden="true">fas {{currentCont === (index + 1)?'fa-angle-up':'fa-angle-down'}}</v-icon>
        </button>
        <div class="accordion-cont" :class="currentCont === (index + 1)?'active':''">
          <slot :name="'cont-'+index" v-if="currentCont === (index + 1)">
          </slot>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  props: {
    numberAccor: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentCont: 0
    };
  },
  methods: {
    accorClick(event) {
      if (this.activeAccor[event].active) {
        this.currentCont = 0;
        this.activeAccor[event].active = false;
      } else {
        this.activeAccor.map( (elem) => {
          return elem.active = false
        })
        this.currentCont = event + 1;
        this.activeAccor[event].active = true;
      }
    }
  },
  computed: {
    activeAccor() {
      var arrayBots = [];
      for (let index = 0; index < this.numberAccor; index++) {
        arrayBots.push({
          active: false
        });
      }
      return arrayBots;
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";
.accordion {
  width: 100%;
  margin: auto;
  max-width: 900px;
  font-size: 1.2rem;
  //  background-color: red;
  .accordion-bot {
    width: 100%;
    text-align: left;
    padding: 5px 10px;
    color: #444;
    font-weight: bold;
    border-radius: 3px;
    background-color: #eee;
    @include shadow( 0 0 5px #555);
    border-bottom: solid 2px #bbb;
    &:hover {
      background-color: #ccc;
    }
    &:focus{
      outline: solid 1px $primary-red;
    }
    i {
      font-weight: bold;
      color: $primary-red;
      float: right;
    }
  }
  .accordion-cont {
    min-height: 0px;
    width: 100%;
    padding: 0px 10px;
    @include shadow( 0 0 5px #555);
    @include transit(all, 0.5s);
    &.active {
      padding: 10px 10px;
      min-height: 100px;
      overflow: hidden;
    }
  }
}
</style>




// WEBPACK FOOTER //
// accordion.vue?6769c2ca